import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useMemo, useRef } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './AgentChatOpenState.module.scss';
import { ChatInput } from './ChatInput';
import { MessageThread } from './MessageThread';
const STICKY_THRESHOLD_PX = 32;
const SCROLLED_THRESHOLD_PX = 2;
export const GetAgentChatOpenStateTID = (parentTestId)=>getTestIds(parentTestId);
export const AgentChatOpenState = (param)=>{
    let { chat, isAutoSaving, onSubmitPrompt, onPdfUpload, onRemoveAttachment, onDismissProposal, onApplyProposal, onListSelectClick, onSubmitFeedback, onDismissFeedback, onScrolledChange, testId } = param;
    const { AgentChatOpenStateTID } = useMemo(()=>GetAgentChatOpenStateTID(testId), [
        testId
    ]);
    const bodyRef = useRef(null);
    const contentRef = useRef(null);
    const isStickyRef = useRef(true);
    const isScrolledRef = useRef(false);
    const onBodyScroll = ()=>{
        const body = bodyRef.current;
        if (body == null) return;
        const distanceFromBottom = body.scrollHeight - body.scrollTop - body.clientHeight;
        isStickyRef.current = distanceFromBottom <= STICKY_THRESHOLD_PX;
        const scrolled = body.scrollTop > SCROLLED_THRESHOLD_PX;
        if (scrolled !== isScrolledRef.current) {
            isScrolledRef.current = scrolled;
            onScrolledChange === null || onScrolledChange === void 0 ? void 0 : onScrolledChange(scrolled);
        }
    };
    useLayoutEffect(()=>{
        const body = bodyRef.current;
        const content = contentRef.current;
        if (body == null || content == null) return;
        const observer = new ResizeObserver(()=>{
            if (!isStickyRef.current) return;
            body.scrollTop = body.scrollHeight;
        });
        observer.observe(content);
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: bodyRef,
                onScroll: onBodyScroll,
                className: styles.body,
                children: /*#__PURE__*/ _jsx("div", {
                    ref: contentRef,
                    children: /*#__PURE__*/ _jsx(MessageThread, {
                        messages: chat.messages,
                        isThinking: chat.isThinking,
                        activeToolCalls: chat.activeToolCalls,
                        thinkingText: chat.thinkingText,
                        thinkingLabel: chat.thinkingLabel,
                        error: chat.error,
                        onDismissProposal: onDismissProposal,
                        onApplyProposal: onApplyProposal,
                        onListSelectClick: onListSelectClick,
                        onSubmitFeedback: onSubmitFeedback,
                        onDismissFeedback: onDismissFeedback,
                        onSuggestionClick: (messageId, suggestion)=>onApplyProposal(messageId, [
                                suggestion.id
                            ]),
                        testId: AgentChatOpenStateTID.MessageThread()
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.inputBlock,
                children: /*#__PURE__*/ _jsx(ChatInput, {
                    isThinking: chat.isThinking,
                    isUploading: chat.isUploading,
                    isAutoSaving: isAutoSaving,
                    uploadingFileName: chat.uploadingFileName,
                    pendingAttachment: chat.pendingAttachment,
                    onSubmit: onSubmitPrompt,
                    onPdfUpload: onPdfUpload,
                    onRemoveAttachment: onRemoveAttachment,
                    testId: AgentChatOpenStateTID.ChatInput()
                })
            })
        ]
    });
};
